import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useCreateDocumentType = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while creating document type");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (data) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/documenttypes`,
        data
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Document type created successfully");
      queryClient.invalidateQueries({ queryKey: ["documentTypes"] });
    },
    onError: handleNetworkError,
  });
};
